/** Help: the glossary and the runbook index (U099). No network: the content is bundled. */
import { h, setChildren } from "../../app/dom.ts";
import type { ViewContext, ViewHandle } from "../../app/view.ts";
import { handleOf, makeFrame } from "../frame.ts";
import { GLOSSARY, RUNBOOKS, filterGlossary } from "./model.ts";
import "../../styles/delivery.css";

/** Mount the help view. */
export function mountHelp(ctx: ViewContext): ViewHandle {
  const frame = makeFrame("help", "Help and glossary");
  const list = h("dl", { class: "glossary" });
  const count = h("p", { class: "note", attrs: { role: "status", "aria-live": "polite" } });
  const search = h("input", {
    attrs: { type: "search", name: "glossary-search", autocomplete: "off" },
  });
  const draw = (): void => {
    const shown = filterGlossary(GLOSSARY, search.value);
    count.textContent = `${String(shown.length)} of ${String(GLOSSARY.length)} terms`;
    setChildren(
      list,
      shown.flatMap((entry) => [h("dt", {}, entry.term), h("dd", {}, entry.definition)]),
    );
  };
  ctx.scope.listen(search, "input", draw);
  draw();
  frame.body.append(
    h("h2", {}, "Glossary"),
    h("label", {}, "Search the glossary ", search),
    count,
    list,
    h(
      "section",
      { attrs: { "aria-labelledby": "runbooks-title" } },
      h("h2", { attrs: { id: "runbooks-title" } }, "Runbooks"),
      h(
        "p",
        { class: "note" },
        "The runbooks live in the repository under docs/runbooks. This is the index; open the file by name.",
      ),
      h(
        "ul",
        { class: "runbooks" },
        ...RUNBOOKS.map((entry) =>
          h(
            "li",
            {},
            h("strong", {}, entry.title),
            " ",
            h("code", {}, `docs/runbooks/${entry.file}`),
          ),
        ),
      ),
    ),
  );
  return handleOf(frame, ctx);
}
